import * as angular from 'angular';
import type {ISCEService} from 'angular';
import GenerateMenuController from './kp-generate-menu.controller';
import {isGoToMenuItemAction} from '../../../services/defined-action-performer';

/**
 * @ngdoc directive
 * @name kpGenerateFullWidthMenu
 * @module portaro.components.main-menu
 * @restrict E
 *
 * @param {Array<menuItem>} menuStructure Menu structure definition
 * @param {expression=} onTransitionComplete If menu shift animation ends, expression is evaluated.
 *
 * @description
 * Internal directive for generating menu HTML structure from given input data
 */

export default class GenerateFullWidthMenuDirective {
    static directiveName = 'kpGenerateFullWidthMenu';

    restrict = 'E';
    controller = GenerateMenuController;
    controllerAs = 'gfwdc';

    /*@ngInject*/
    constructor(private $parse,
                private $compile,
                private $sce: ISCEService) {
    }

    preLink($scope, $element, attrs, controller) {
        /**
         * @type {Array<singleMenuItem|multiMenuItem>}
         */
        const menuStructure = this.$parse(attrs.menuStructure)($scope);

        controller.setMenuStructure(menuStructure);

        const generatedMenu = angular.element(this.generateMenu(menuStructure));
        $element.append(generatedMenu);
        this.$compile(generatedMenu)($scope);

        $scope.transitionComplete = () => {
            if (attrs.onTransitionComplete) {
                this.$parse(attrs.onTransitionComplete)($scope);
            }
        };
    }

    private generateMenu(menuStructure) {
        return `
            <ul class="kp-mm-doc-set-nav-tab-list kp-mm-overflow-tabs-scroll" style="min-width: 561px; left: 0;" kp-on-transition-end="transitionComplete()" kp-on-transition-end-properties="left">
                ${menuStructure.map((menuItem, index) => {
            if (menuItem.type === 'user') {
                return '';
            } else if (menuItem.submenu) {
                return this.generateMultiMenuItem(menuItem, index);
            } else {
                return this.generateSingleMenuItem(menuItem, index);
            }
        }).join('')}
            </ul>
        `;
    }

    private generateSingleMenuItem(menuItem, index) {
        return `<li class="kp-mm-doc-set-nav-tab-container">
                    <a class="kp-mm-doc-set-nav-tab menu-id-${menuItem.id}" href="${this.generateHref(menuItem)}" ng-click="gfwdc.performClick($event, ${index})" kp-add-class-on-hover="'onhover'">${menuItem.text}</a>
                </li>`;
    }

    private generateMultiMenuItem(menuItem, index) {
        return `<li class="kp-mm-doc-set-nav-tab-container" uib-dropdown="" dropdown-append-to-body="" kp-dropdown-on-hover="" kp-add-class-on-hover="'onhover'">
                    <a class="kp-mm-doc-set-nav-tab menu-id-${menuItem.id}" href="javascript:void(0)" uib-dropdown-toggle="">${menuItem.text}</a>
                    <ul class="nav-dropdown kp-main-menu" uib-dropdown-menu="">
                        ${menuItem.submenu.map((element, subIndex) => `<li>${this.generateSingleSubmenuItem(element, index, subIndex)}</li>`).join('')}
                    </ul>
                </li>`;
    }

    private generateSingleSubmenuItem(menuItem, index, subIndex) {
        return `<a class="menu-id-${menuItem.id}" href="${this.generateHref(menuItem)}" ng-click="gfwdc.performClick($event, ${index}, ${subIndex})" kp-add-class-on-hover="'onhover'">${menuItem.text}</a>`;
    }

    private generateHref(menuItem) {
        const action = menuItem.action;
        if (isGoToMenuItemAction(action)) {
            return action.path;
        }
        return this.$sce.trustAsHtml('javascript:void(0)');
    }
}